function  validateVar(variable) {
    if (typeof variable === "undefined" || variable === null || variable === "null" || variable === "" && variable !== "ERR") return false;
    return true;
}
export default validateVar;